import React, { useState, useEffect } from "react";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import { Container, Input } from "./styles";
import { ModalDivX } from "../../../ModalDivX";
import api from "../../../../Services/api";
import { ModalLoader } from "../../../ModalLoader";
import { Alert } from "../../../Error/Alert";
import { Paperclip, Plus } from "react-feather";
import { IAnexos } from "..";
import { Button } from "./styles";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  anexo: IAnexos;
  handleUpdateAnexo(title: string): void;
}

export function EditarAnexoModal({
  open,
  onClose,
  anexo,
  handleUpdateAnexo,
}: Props) {
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  const { cartorioIsLogged, cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  useEffect(() => {
    setTitle(anexo.TITULO);
  }, [open]);

  function validaForm() {
    if (title.trim().length == 0) {
      setError({
        message: "O título não pode ser vázio.",
        title: "Título inválido!",
      });
      return false;
    }

    return true;
  }

  async function post() {
    if (validaForm())
      try {
        setLoading(true);
        if (funcionarioCartorioIsLogged) {
            await checarTokenFuncionario();
          }
    
          if (cartorioIsLogged) {
            await checarToken();
          }
        await api.put(`/imovel-anexos`, {
          TITULO: title,
          IMOVEL_ID: anexo.IMOVEL_ID,
          IDENTIFICADOR: anexo.IDENTIFICADOR,
        });
        handleUpdateAnexo(title);
        onClose();
      } catch (error) {
        setError({
          title: "Não foi possível salvar a alteração!",
          message:
            "Ocorreu um erro durante a atualização do anexo, tente novamente!",
        });
      } finally {
        setLoading(false);
      }
  }

  return (
    <>
      <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
        <ModalDivX execute={onClose} />

        <Container>
          <Input
            placeholder="TÍTULO"
            value={title}
            onChange={(ev) => setTitle(ev.target.value)}
            maxLength={50}
          />

          <Button onClick={post}>CONFIRMAR</Button>
        </Container>
      </Modal>
      <ModalLoader loading={loading} />
      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </>
  );
}
